import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';

import { Config } from '../../../config/config';
import { VnptHttpService } from '../../services/vnpt-http.service';
import { Observable } from 'rxjs/Observable';
import { DMCoQuan, SearchDMCoQuan } from './dm-co-quan';
@Injectable()
export class DMCoQuanService {
    
    constructor(private http: Http) { }

    Tao_CoQuan(CQ) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = CQ;
        return this.http.post(Config.apiUrl + 'DMCoQuan/Tao_CoQuan', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    Huy_CoQuan(CQ) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = CQ;
        return this.http.post(Config.apiUrl + 'DMCoQuan/Huy_CoQuan', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSachLoaiCoQuan() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + 'DMCoQuan/GetList_DanhSachLoaiCoQuan', JSON.stringify({}), { headers: headers }).map(resp => resp.json());
    }
    DanhSachCoQuanTree(DSCQ) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = DSCQ;
        return this.http.post(Config.apiUrl + 'DMCoQuan/GetListCoQuan_Tree', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSachCoQuan(DSCQ) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = DSCQ;
        return this.http.post(Config.apiUrl + 'DMCoQuan/GetList_DanhSachCoQuan', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSachCoQuanLoaiCoQuan(DSCQ) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = DSCQ;
        return this.http.post(Config.apiUrl + 'DMCoQuan/GetList_DanhSachCoQuanLoaiCoQuan', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSachCoQuan_LoaiCoQuan_Tree(CQ) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = CQ;
        return this.http.post(Config.apiUrl + 'DMCoQuan/GetListCoQuan_LoaiCoQuan_Tree', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    CoQuan_TimKiem_Tree(CQ) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = CQ;
        return this.http.post(Config.apiUrl + 'DMCoQuan/CoQuan_TimKiem_Tree', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    GetListAll() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + 'DMCoQuan/GetListAll', { headers: headers }).map(resp => resp.json());
    }
    // dung cho don vi xu ly getlist
    GetList(idTinhThanh: number) {
        let headers = new Headers();

        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = { IdTinhThanh: idTinhThanh };
        return this.http.post(Config.apiUrl + 'DMCoQuan/GetList', JSON.stringify(data), { headers: headers }).map(resp => resp.json());

    }
    //dung cho dm thiet bi getlist
    GetlistDSCQ(idloaicoquan,idcoquan) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {IdLoaiCoQuan: idloaicoquan, IdCoQuan:idcoquan};
        return this.http.post(Config.apiUrl + 'DMCoQuan/GetListCoQuan', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    GetListByDonVi(idDonVi: number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + 'DMCoQuan/GetListByDonVi?IdDonVi=' + idDonVi, { headers: headers }).map(resp => resp.json());
    }
    GetListByDonViTB(idDonVi: number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + 'DMCoQuan/GetListByDonViTB?IdDonVi=' + idDonVi, { headers: headers }).map(resp => resp.json());
    }
    GetListCoQuanByDonVi(idCoQuan: number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + 'DMCoQuan/GetListCoQuanByDonVi?IdCoQuan=' + idCoQuan, { headers: headers }).map(resp => resp.json());
    }
    GetListBySanPham(IdSanPham: number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + 'DMCoQuan/GetListBySanPham?IdSanPham=' + IdSanPham, { headers: headers }).map(resp => resp.json());
    }
    GetListByLoai_SanPham(IdLoaiCoQuan: number,IdSanPham: number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + 'DMCoQuan/GetListByLoai_SanPham?IdLoaiCoQuan=' + IdLoaiCoQuan+'&IdSanPham='+IdSanPham, { headers: headers }).map(resp => resp.json());
    }
     KiemTra_CoQuanCapCha(CQ) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = CQ;
        return this.http.post(Config.apiUrl + 'DMCoQuan/KiemTraCapCha', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    DanhSachNhomCoQuanByCoQuan(IdCoQuan: number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + 'DMCoQuan/DanhSachNhomCoQuan_ByCoQuan?IdCoQuan=' + IdCoQuan, { headers: headers }).map(resp => resp.json());
    }
    Luu_DinhMucSanPham(DM) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = DM;
        return this.http.post(Config.apiUrl + 'DMCoQuan/Luu_DinhMucSanPham', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    GetListByCoQuan(idKhuVuc:number, idCoQuan: number, op:number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + 'DMCoQuan/GetListByCoQuan?IdKhuVuc='+idKhuVuc+'&IdCoQuan=' + idCoQuan +"&Op=" +op, { headers: headers }).map(resp => resp.json());
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/he-thong/dm-co-quan/dm-co-quan.service.ts